import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function MainOffer() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    provincia: '', poblacion: '', empresa: '', nombre: '', cargo: '', email: '', telefono: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSubmitStatus('success');
      setFormData({ provincia: '', poblacion: '', empresa: '', nombre: '', cargo: '', email: '', telefono: '' });
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const includes = [
    'offer.include1', 'offer.include2', 'offer.include3', 'offer.include4',
    'offer.include5', 'offer.include6', 'offer.include7'
  ];

  return (
    <section id="oferta" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">{t('offer.titulo')}</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">{t('offer.subtitulo')}</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">{t('offer.queIncluye')}</h3>
              <div className="space-y-4 mb-8">
                {includes.map((key, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-teal-600 text-sm"></i>
                    </div>
                    <span className="text-gray-700">{t(key)}</span>
                  </div>
                ))}
              </div>
              <div className="bg-teal-50 rounded-xl p-6">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-time-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">{t('offer.entrega')}</h4>
                    <p className="text-gray-600 text-sm">{t('offer.entregaDesc')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <form onSubmit={handleSubmit}>
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="provincia" className="block text-sm font-medium text-gray-700 mb-2">{t('offer.form.provincia')} *</label>
                    <input type="text" id="provincia" name="provincia" value={formData.provincia} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder={t('offer.form.provinciaPlaceholder')} />
                  </div>
                  <div>
                    <label htmlFor="poblacion" className="block text-sm font-medium text-gray-700 mb-2">{t('offer.form.poblacion')} *</label>
                    <input type="text" id="poblacion" name="poblacion" value={formData.poblacion} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder={t('offer.form.poblacionPlaceholder')} />
                  </div>
                </div>
                <div className="mb-6">
                  <label htmlFor="empresa" className="block text-sm font-medium text-gray-700 mb-2">{t('offer.form.empresa')} *</label>
                  <input type="text" id="empresa" name="empresa" value={formData.empresa} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder={t('offer.form.empresaPlaceholder')} />
                </div>
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-2">{t('offer.form.nombre')} *</label>
                    <input type="text" id="nombre" name="nombre" value={formData.nombre} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder={t('offer.form.nombrePlaceholder')} />
                  </div>
                  <div>
                    <label htmlFor="cargo" className="block text-sm font-medium text-gray-700 mb-2">{t('offer.form.cargo')} *</label>
                    <input type="text" id="cargo" name="cargo" value={formData.cargo} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder={t('offer.form.cargoPlaceholder')} />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">{t('offer.form.email')} *</label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder={t('offer.form.emailPlaceholder')} />
                  </div>
                  <div>
                    <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">{t('offer.form.telefono')} *</label>
                    <input type="tel" id="telefono" name="telefono" value={formData.telefono} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder={t('offer.form.telefonoPlaceholder')} />
                  </div>
                </div>

                {submitStatus === 'success' && (
                  <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                    <div className="flex items-center space-x-2">
                      <i className="ri-check-circle-line text-green-600"></i>
                      <span className="text-green-800 font-medium">{t('offer.form.exito')}</span>
                    </div>
                    <p className="text-green-700 text-sm mt-1">{t('offer.form.exitoDesc')}</p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                    <div className="flex items-center space-x-2">
                      <i className="ri-error-warning-line text-red-600"></i>
                      <span className="text-red-800 font-medium">{t('offer.form.error')}</span>
                    </div>
                    <p className="text-red-700 text-sm mt-1">{t('offer.form.errorDesc')}</p>
                  </div>
                )}

                <button type="submit" disabled={isSubmitting} className="w-full bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white py-4 rounded-lg font-semibold text-lg transition-colors duration-200">
                  {isSubmitting ? t('offer.form.enviando') : t('offer.form.enviar')}
                </button>
                <p className="text-xs text-gray-500 text-center mt-4">{t('offer.form.privacidad')}</p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
